// Initial state 
const state = {
    merge_source_length: 0,
    merge_destination_length: 0,
    temp_merge_performed: false,
    max_source_patients_count: 0,
    patient_card_rows_count: 0,
    default_selected_card: null,
    merge_requests_list_page_size: 10,
    merge_requests_received_count: null,
    merge_requests_draft_count: null,
    merge_requests_pending_count: null,
    MaxPendingReceivedRequests: null
};

// Get data
const getters = {
    merge_source_length(state) {
        return state.merge_source_length;
    },
    merge_destination_length(state) {
        return state.merge_destination_length;
    },
    temp_merge_performed(state) {
        return state.temp_merge_performed;
    },
    max_source_patients_count(state) {
        return state.max_source_patients_count;
    },
    patient_card_rows_count(state) {
        return state.patient_card_rows_count;
    },
    default_selected_card(state) {
        return state.default_selected_card;
    },
    merge_requests_list_page_size(state) {
        return state.merge_requests_list_page_size;
    },
    merge_requests_received_count(state) {
        return state.merge_requests_received_count;
    },
    merge_requests_draft_count(state) {
        return state.merge_requests_draft_count;
    },
    merge_requests_pending_count(state) {
        return state.merge_requests_pending_count;
    },
    getMaxPendingReceivedRequests(state) {
        return state.MaxPendingReceivedRequests;
    },
    getInProgressMergeRequestsCount(state) {
        return (state.merge_requests_received_count == null ? 0 : state.merge_requests_received_count) +
            (state.merge_requests_pending_count == null ? 0 : state.merge_requests_pending_count) +
            (state.merge_requests_draft_count == null ? 0 : state.merge_requests_draft_count);
    }
};

// Update Data "mutations"
const mutations = {
    save_merge_source_length(state, payload) {
        state.merge_source_length = payload;
    },
    save_merge_destination_length(state, payload) {
        state.merge_destination_length = payload;
    },
    save_temp_merge_performed(state, payload) {
        state.temp_merge_performed = payload;
    },
    save_max_source_patients_count(state, payload) {
        state.max_source_patients_count = payload;
    },
    save_patient_card_rows_count(state, payload) {
        state.patient_card_rows_count = payload;
    },
    save_default_selected_card(state, payload) {
        state.default_selected_card = payload;
    },
    save_merge_requests_list_page_size(state, payload) {
        state.merge_requests_list_page_size = payload;
    },
    save_merge_requests_received_count(state, payload) {
        state.merge_requests_received_count = payload;
    },
    save_merge_requests_draft_count(state, payload) {
        state.merge_requests_draft_count = payload;
    },
    save_merge_requests_pending_count(state, payload) {
        state.merge_requests_pending_count = payload;
    },
    setMaxPendingReceivedRequests(state, payload) {
        state.MaxPendingReceivedRequests = payload;
    }
};

const actions = {
    load_merge_source_length(context, payload) {
        context.commit('save_merge_source_length', payload);
    },
    load_merge_destination_length(context, payload) {
        context.commit('save_merge_destination_length', payload);
    },
    load_temp_merge_performed(context, payload) {
        context.commit('save_temp_merge_performed', payload);
    },
    load_max_source_patients_count(context, payload) {
        context.commit('save_max_source_patients_count', payload);
    },
    load_patient_card_rows_count(context, payload) {
        context.commit('save_patient_card_rows_count', payload);
    },
    load_default_selected_card(context, payload) {
        context.commit('save_default_selected_card', payload);
    },
    load_merge_requests_list_page_size(context, payload) {
        context.commit('save_merge_requests_list_page_size', payload);
    },
    load_merge_requests_received_count(context, payload) {
        context.commit('save_merge_requests_received_count', payload);
    },
    load_merge_requests_draft_count(context, payload) {
        context.commit('save_merge_requests_draft_count', payload);
    },
    load_merge_requests_pending_count(context, payload) {
        context.commit('save_merge_requests_pending_count', payload);
    }
}

export default {
    mutations,
    state,
    getters,
    actions
};